<template>
<section>
    <div v-if="report.publicRecords != null && report.publicRecords.length > 0" class="row">
        <div class="col-sm-12">
            <div class="card">
                <div v-if="report.publicRecords.length > 0" class="card-body">
                    <div class="row">
                        <div class="col-lg-3 col-xl-3 col-md-3" v-for="(publicRecord, loop) in report.listPublicRecords">
                            <div class="card shadow-none bg-transparent border-success" data-toggle="modal" :data-target="'#public_records_modal_'+loop">
                                <div class="card-body">
                                    <h4 class="card-title mb-50 text-primary account-title">
                                        <strong>
                                            {{ getAccountDetail(publicRecord).furnisher_name }}
                                        </strong>
                                        <span v-if="reportStore.isNew('listPublicRecords', publicRecord)" class="ml-1 badge badge-pill badge-glow badge-down badge-primary" style="font-size:10px">
                                            New
                                        </span>
                                    </h4>
                                    <p class="card-text mb-0">
                                        <span class="text-secondary">
                                            <strong>
                                                <i class="fa fa-align-left"></i>
                                                Reference Number:
                                            </strong>
                                        </span>
                                        {{ getAccountDetail(publicRecord).reference_number }}
                                    </p>
                                    <p class="card-text mb-0">
                                        <span class="text-secondary">
                                            <strong style="font-size:12px">
                                                <i class="fa fa-usd"></i>
                                                TYPE: 
                                            </strong>
                                        </span>
                                        {{ getAccountDetail(publicRecord).type }}
                                    </p>
                                    <p class="card-text mb-0" >
                                        <span class="text-secondary">
                                            <strong style="font-size:12px">
                                                <i class="fa fa-info-circle "></i>
                                                ACCOUNT STATUS: 
                                            </strong>
                                        </span>
                                        <span>
                                            {{ getAccountDetail(publicRecord).status }}
                                        </span>
                                    </p>
                                    <p class="card-text mb-0">
                                        <span class="text-secondary">
                                            <strong style="font-size:12px">
                                                <i class="fa fa-info-circle"></i>
                                                DATE FILED: 
                                            </strong>
                                        </span>
                                        <span class="badge badge-pill badge-glow badge-down">
                                            {{ getAccountDetail(publicRecord).date_filed_reported }}
                                        </span>
                                    </p>
                                    <p class="text-primary float-right mb-0" style="font-size:12px;cursor: pointer;">
                                        <u>View Details</u>
                                    </p>
                                </div>
                            </div>
                            <div class="modal fade text-left" :id="'public_records_modal_'+loop" tabindex="-1" role="dialog" aria-labelledby="public_records_modal" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h4 class="modal-title" id="myModalLabel16">{{ getAccountDetail(publicRecord).furnisher_name }}</h4>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="table-responsive">
                                                <table class="table table-success table-striped table-hover mb-0">
                                                    <thead class="thead-primary">
                                                        <tr>
                                                            <th style="width:100px"></th>
                                                            <th style="width:100px">
                                                                <img :src="reportStore.images.transunion" alt="image" width="75" height="75" class="d-block">
                                                            </th>
                                                            <th style="width:100px">
                                                                <img :src="reportStore.images.experian" alt="image" width="75" height="75" class="d-block">
                                                            </th>
                                                            <th style="width:100px">
                                                                <img :src="reportStore.images.equifax" alt="image" width="75" height="75" class="d-block">
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="table-striped" >
                                                        <tr scope="row">
                                                            <td>Reference Number</td>
                                                            <td>
                                                                <p class="mb-0">
                                                                    {{ publicRecord[0].reference_number }}
                                                                </p>
                                                                <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedPublicRecord(publicRecord).length > 0 && (publicRecord[0].reference_number != reportStore.getDeletedPublicRecord(publicRecord)[0].reference_number)">
                                                                    {{ reportStore.getDeletedPublicRecord(publicRecord)[0].reference_number }}
                                                                    <span class="text-danger">
                                                                        (Deleted)
                                                                    </span>
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p class="mb-0">
                                                                    {{ publicRecord[1].reference_number }}
                                                                </p>
                                                                <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedPublicRecord(publicRecord).length > 0 && (publicRecord[1].reference_number != reportStore.getDeletedPublicRecord(publicRecord)[1].reference_number)">
                                                                    {{ reportStore.getDeletedPublicRecord(publicRecord)[1].reference_number }}
                                                                    <span class="text-danger">
                                                                        (Deleted)
                                                                    </span>
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p class="mb-0">
                                                                    {{ publicRecord[2].reference_number }}
                                                                </p>
                                                                <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedPublicRecord(publicRecord).length > 0 && (publicRecord[1].reference_number != reportStore.getDeletedPublicRecord(publicRecord)[1].reference_number)">
                                                                    {{ reportStore.getDeletedPublicRecord(publicRecord)[1].reference_number }}
                                                                    <span class="text-danger">
                                                                        (Deleted)
                                                                    </span>
                                                                </p>
                                                            </td>
                                                        </tr>
                                                        <tr scope="row">
                                                            <td>TYPE</td>
                                                            <td>
                                                                <p class="mb-0">
                                                                    {{ publicRecord[0].type }}
                                                                </p>
                                                                <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedPublicRecord(publicRecord).length > 0 && (publicRecord[0].type != reportStore.getDeletedPublicRecord(publicRecord)[0].type)">
                                                                    {{ reportStore.getDeletedPublicRecord(publicRecord)[0].type }}
                                                                    <span class="text-danger">
                                                                        (Deleted)
                                                                    </span>
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p class="mb-0">
                                                                    {{ publicRecord[1].type }}
                                                                </p>
                                                                <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedPublicRecord(publicRecord).length > 0 && (publicRecord[1].type != reportStore.getDeletedPublicRecord(publicRecord)[1].type)">
                                                                    {{ reportStore.getDeletedPublicRecord(publicRecord)[1].type }}
                                                                    <span class="text-danger">
                                                                        (Deleted)
                                                                    </span>
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p class="mb-0">
                                                                    {{ publicRecord[2].type }}
                                                                </p>
                                                                <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedPublicRecord(publicRecord).length > 0 && (publicRecord[2].type != reportStore.getDeletedPublicRecord(publicRecord)[2].type)">
                                                                    {{ reportStore.getDeletedPublicRecord(publicRecord)[2].type }}
                                                                    <span class="text-danger">
                                                                        (Deleted)
                                                                    </span>
                                                                </p>
                                                            </td>
                                                        </tr>
                                                        <tr scope="row">
                                                            <td>ACCOUNT STATUS</td>
                                                            <td>
                                                                <p class="mb-0">
                                                                    {{ publicRecord[0].status }}
                                                                </p>
                                                                <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedPublicRecord(publicRecord).length > 0 && (publicRecord[0].status != reportStore.getDeletedPublicRecord(publicRecord)[0].status)">
                                                                    {{ reportStore.getDeletedPublicRecord(publicRecord)[0].status }}
                                                                    <span class="text-danger">
                                                                        (Deleted)
                                                                    </span>
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p class="mb-0">
                                                                    {{ publicRecord[1].status }}
                                                                </p>
                                                                <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedPublicRecord(publicRecord).length > 0 && (publicRecord[1].status != reportStore.getDeletedPublicRecord(publicRecord)[1].status)">
                                                                    {{ reportStore.getDeletedPublicRecord(publicRecord)[1].status }}
                                                                    <span class="text-danger">
                                                                        (Deleted)
                                                                    </span>
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p class="mb-0">
                                                                    {{ publicRecord[2].status }}
                                                                </p>
                                                                <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedPublicRecord(publicRecord).length > 0 && (publicRecord[2].status != reportStore.getDeletedPublicRecord(publicRecord)[2].status)">
                                                                    {{ reportStore.getDeletedPublicRecord(publicRecord)[2].status }}
                                                                    <span class="text-danger">
                                                                        (Deleted)
                                                                    </span>
                                                                </p>
                                                            </td>
                                                        </tr>
                                                        <tr scope="row">
                                                            <td>DATE FILED</td>
                                                            <td>
                                                                <p class="mb-0">
                                                                    {{ publicRecord[0].date_filed_reported }}
                                                                </p>
                                                                <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedPublicRecord(publicRecord).length > 0 && (publicRecord[0].date_filed_reported != reportStore.getDeletedPublicRecord(publicRecord)[0].date_filed_reported)">
                                                                    {{ reportStore.getDeletedPublicRecord(publicRecord)[0].date_filed_reported }}
                                                                    <span class="text-danger">
                                                                        (Deleted)
                                                                    </span>
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p class="mb-0">
                                                                    {{ publicRecord[1].date_filed_reported }}
                                                                </p>
                                                                <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedPublicRecord(publicRecord).length > 0 && (publicRecord[1].date_filed_reported != reportStore.getDeletedPublicRecord(publicRecord)[1].date_filed_reported)">
                                                                    {{ reportStore.getDeletedPublicRecord(publicRecord)[1].date_filed_reported }}
                                                                    <span class="text-danger">
                                                                        (Deleted)
                                                                    </span>
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p class="mb-0">
                                                                    {{ publicRecord[2].date_filed_reported }}
                                                                </p>
                                                                <p class="mb-0 text-danger" v-if="reportStore.reports[email].haveOldReport && reportStore.getDeletedPublicRecord(publicRecord).length > 0 && (publicRecord[2].date_filed_reported != reportStore.getDeletedPublicRecord(publicRecord)[2].date_filed_reported)">
                                                                    {{ reportStore.getDeletedPublicRecord(publicRecord)[2].date_filed_reported }}
                                                                    <span class="text-danger">
                                                                        (Deleted)
                                                                    </span>
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="reportStore.getDeletedAccounts('listPublicRecords') != null && reportStore.getDeletedAccounts('listPublicRecords').length > 0" class="col-lg-3 col-xl-3 col-md-3" v-for="(publicRecord, loop) in reportStore.getDeletedAccounts('listPublicRecords')">
                            <div class="card shadow-none bg-transparent border-success" data-toggle="modal" :data-target="'#public_records_deleted_modal'+loop">
                                <div class="card-body">
                                    <h4 class="card-title mb-50 text-primary account-title">
                                        <strong>
                                            {{ getAccountDetail(publicRecord).furnisher_name }}
                                        </strong>
                                        <span class="ml-1 badge badge-pill badge-glow badge-down badge-danger" style="font-size:10px">
                                            Deleted
                                        </span>
                                    </h4>
                                    <p class="card-text mb-0">
                                        <span class="text-secondary">
                                            <strong>
                                                <i class="fa fa-align-left"></i>
                                                Reference Number:
                                            </strong>
                                        </span>
                                        {{ getAccountDetail(publicRecord).reference_number }}
                                    </p>
                                    <p class="card-text mb-0">
                                        <span class="text-secondary">
                                            <strong style="font-size:12px">
                                                <i class="fa fa-usd"></i>
                                                TYPE: 
                                            </strong>
                                        </span>
                                        {{ getAccountDetail(publicRecord).type }}
                                    </p>
                                    <p class="card-text mb-0" >
                                        <span class="text-secondary">
                                            <strong style="font-size:12px">
                                                <i class="fa fa-info-circle "></i>
                                                ACCOUNT STATUS: 
                                            </strong>
                                        </span>
                                        <span>
                                            {{ getAccountDetail(publicRecord).status }}
                                        </span>
                                    </p>
                                    <p class="card-text mb-0">
                                        <span class="text-secondary">
                                            <strong style="font-size:12px">
                                                <i class="fa fa-info-circle"></i>
                                                DATE FILED: 
                                            </strong>
                                        </span>
                                        <span class="badge badge-pill badge-glow badge-down">
                                            {{ getAccountDetail(publicRecord).date_filed_reported }}
                                        </span>
                                    </p>
                                    <p class="text-primary float-right mb-0" style="font-size:12px;cursor: pointer;">
                                        <u>View Details</u>
                                    </p>
                                </div>
                            </div>
                            <div class="modal fade text-left" :id="'public_records_deleted_modal'+loop" tabindex="-1" role="dialog" aria-labelledby="public_records_deleted_modal" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h4 class="modal-title" id="myModalLabel16">{{ getAccountDetail(publicRecord).furnisher_name }}</h4>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="table-responsive">
                                                <table class="table table-success table-hover table-striped mb-0">
                                                    <thead class="thead-primary">
                                                        <tr>
                                                            <th colspan="4">{{ getAccountDetail(publicRecord).furnisher_name }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="table-striped" >
                                                        <tr>
                                                            <th></th>
                                                            <th>
                                                                <img :src="reportStore.images.transunion" alt="image" width="75" height="75" class="d-block">
                                                            </th>
                                                            <th>
                                                                <img :src="reportStore.images.experian" alt="image" width="75" height="75" class="d-block">
                                                            </th>
                                                            <th>
                                                                <img :src="reportStore.images.equifax" alt="image" width="75" height="75" class="d-block">
                                                            </th>
                                                        </tr>
                                                        <tr scope="row">
                                                            <td>Reference Number</td>
                                                            <td>{{ publicRecord[0].reference_number }}</td>
                                                            <td>{{ publicRecord[1].reference_number }}</td>
                                                            <td>{{ publicRecord[2].reference_number }}</td>
                                                        </tr>
                                                        <tr scope="row">
                                                            <td>TYPE</td>
                                                            <td>{{ publicRecord[0].type }}</td>
                                                            <td>{{ publicRecord[1].type }}</td>
                                                            <td>{{ publicRecord[2].type }}</td>
                                                        </tr>
                                                        <tr scope="row">
                                                            <td>ACCOUNT STATUS</td>
                                                            <td>{{ publicRecord[0].status }}</td>
                                                            <td>{{ publicRecord[1].status }}</td>
                                                            <td>{{ publicRecord[2].status }}</td>
                                                        </tr>
                                                        <tr scope="row">
                                                            <td>DATE FILED</td>
                                                            <td>{{ publicRecord[0].date_filed_reported }}</td>
                                                            <td>{{ publicRecord[1].date_filed_reported }}</td>
                                                            <td>{{ publicRecord[2].date_filed_reported }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="!reportStore.reports[email].haveReport">
        <div class="col-sm-12">
            <div class="card" :class="{ 'shadow': $route.params.client }" >
                <div class="card-body">
                    <div class="mx-auto">
                        <h3 class="text-center text-warning mb-1">Oops...Your Credit Report is Missing.</h3>
                        <h6 class=" text-center text-warning mb-2">In order view the Dispute Center, you must import your Credit Report.
                            <br> If you don't already have a credit report, you can get one by clicking the button below.
                        </h6>
                    </div>
                    <div style="text-align:center;">
                        <a href="https://www.smartcredit.com/?PID=54821" target="_blank" type="submit"
                            class="btn btn-warning ">
                            <i data-feather="external-link" class="mr-25"></i> <span>SmartCredit</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p v-else class="text-center font-medium-3 text-bold-600 warning"> You don't have any Report Data.</p>
</section>
</template>

<script>
    import { reactive, computed } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    export default {
        mounted() {
        },
        props: {
            email: String
        },
        setup(props) {
            return {
                localizationStore: useLocalizationStore(),
                reportStore: useReportStore(),
                report: useReportStore().reports[props.email].report
            }
        },
        methods: {
            getAccountDetail(account) {
                if (
                    !account[0].furnisher_name.includes('-')
                    &&
                    !account[0].reference_number.includes('-')
                ) {
                    return account[0];
                }
                else if (
                    !account[1].furnisher_name.includes('-')
                    &&
                    !account[1].reference_number.includes('-')
                ) {
                    return account[1];
                }
                return account[2];
            }
        },
    }
</script>
